module.exports = __webpack_public_path__ + "static/media/animal-04.856ff9b1.mp3";